// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#pyramid-content
/*всё поле*/ {
  margin-left: 2vw;
  margin-right: 2vw;
  display: grid;
  padding:  0.2% 0.6% 0.3%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-height: 100vh;
}
.pyramid-conteiner {
  display: grid;
  grid-template-rows: 2vh min-content min-content;
  align-items: start;
}


.pyramid-mainsubtitle {
  font-family: "Amatic SC";
  font-size: 2.7vw;
  text-align: center;
  margin-top: 1vh;
  width: 63vw;
}
.pyramid-Logo-name {
  display: grid;
  z-index: 1;
  height: 1vw;
  grid-template-columns: 10vw 63vw 21.8vw;
}
.pyramid-logo {
  display: grid;
      height: 3.4vw;
  place-items: start;
}
.pyramid-fullscreen{
  display: grid;
  height: 1.5vw;
  justify-self: end;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/TaskWindows/PyramidApp/styles/PyramidApp.css"],"names":[],"mappings":";AACA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,wBAAwB;EACxB,yDAAgE;EAChE,4EAA4E;EAC5E,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;AACpB;;;AAGA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,aAAa;MACT,aAAa;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["\n#pyramid-content\n/*всё поле*/ {\n  margin-left: 2vw;\n  margin-right: 2vw;\n  display: grid;\n  padding:  0.2% 0.6% 0.3%;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  min-height: 100vh;\n}\n.pyramid-conteiner {\n  display: grid;\n  grid-template-rows: 2vh min-content min-content;\n  align-items: start;\n}\n\n\n.pyramid-mainsubtitle {\n  font-family: \"Amatic SC\";\n  font-size: 2.7vw;\n  text-align: center;\n  margin-top: 1vh;\n  width: 63vw;\n}\n.pyramid-Logo-name {\n  display: grid;\n  z-index: 1;\n  height: 1vw;\n  grid-template-columns: 10vw 63vw 21.8vw;\n}\n.pyramid-logo {\n  display: grid;\n      height: 3.4vw;\n  place-items: start;\n}\n.pyramid-fullscreen{\n  display: grid;\n  height: 1.5vw;\n  justify-self: end;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
